module.exports = __webpack_public_path__ + "img/stats_mobile_de.3b51023.webp";